import React from "react";
import {
  InputComponentWithBorder,
  SelectWithBorderComponent,
} from "../../../../components/FormFields";
import { AGENCY_SELECT_DROPDOWN_CLASS } from "./style";

const AgencySelectWithBorderComponent = props => (
  <SelectWithBorderComponent
    dropdownClassName={AGENCY_SELECT_DROPDOWN_CLASS}
    {...props}
  />
);

export {
  InputComponentWithBorder,
  AgencySelectWithBorderComponent as SelectWithBorderComponent,
};
